export default class PrivilegeCode {
  constructor(code, desc, parentCode) {
    this.code = code;
    this.desc = desc;
    this.pCode = parentCode;
  }

  getCode() {
    return this.code;
  }

  getDesc() {
    return this.desc;
  }

  getParentCode() {
    return this.pCode;
  }
}

PrivilegeCode.PERSONAL_SETTING = new PrivilegeCode('PERSONAL_SETTING', '个人基本信息设置', '');

// 公海池
PrivilegeCode.LEADS_PUBLIC_POOL_VIEW_LIST = new PrivilegeCode('LEADS_PUBLIC_POOL_VIEW_LIST', '查看线索列表', '');
PrivilegeCode.LEADS_PUBLIC_POOL_VIEW_DETAIL = new PrivilegeCode(
  'LEADS_PUBLIC_POOL_VIEW_DETAIL',
  '查看线索数据详情',
  '',
);
PrivilegeCode.LEADS_PUBLIC_POOL_EDIT_DETAIL = new PrivilegeCode(
  'LEADS_PUBLIC_POOL_EDIT_DETAIL',
  '编辑线索数据详情',
  '',
);
PrivilegeCode.LEADS_PUBLIC_POOL_EXPORT = new PrivilegeCode('LEADS_PUBLIC_POOL_EXPORT', '导出线索数据', '');
PrivilegeCode.LEADS_PUBLIC_POOL_DISTRIBUTE = new PrivilegeCode('LEADS_PUBLIC_POOL_DISTRIBUTE', '分配线索', '');
PrivilegeCode.LEADS_PUBLIC_POOL_CALL = new PrivilegeCode('LEADS_PUBLIC_POOL_CALL', '电话外呼', '');
PrivilegeCode.LEADS_PUBLIC_POOL_UPDATE_STATUS_SCORE = new PrivilegeCode(
  'LEADS_PUBLIC_POOL_UPDATE_STATUS_SCORE',
  '标记线索状态、线索评分',
  '',
);

// 线索管理

PrivilegeCode.LEADS_VIEW_LIST = new PrivilegeCode('LEADS_VIEW_LIST', '查看线索列表', '');
PrivilegeCode.LEADS_VIEW_DETAIL = new PrivilegeCode('LEADS_VIEW_DETAIL', '查看线索数据详情', '');
PrivilegeCode.LEADS_EDIT_DETAIL = new PrivilegeCode('LEADS_EDIT_DETAIL', '编辑线索数据详情', '');
PrivilegeCode.LEADS_SELF_EDIT_DETAIL = new PrivilegeCode('LEADS_SELF_EDIT_DETAIL', '编辑线索数据个人详情', '');
PrivilegeCode.LEADS_GROUP_EDIT_DETAIL = new PrivilegeCode('LEADS_GROUP_EDIT_DETAIL', '编辑线索数据团队详情', '');
PrivilegeCode.LEADS_COMPANY_EDIT_DETAIL = new PrivilegeCode('LEADS_COMPANY_EDIT_DETAIL', '编辑线索数据公司详情', '');
PrivilegeCode.LEADS_EXPORT = new PrivilegeCode(' LEADS_EXPORT', '导出线索数据', '');
PrivilegeCode.LEADS_DISTRIBUTE = new PrivilegeCode('LEADS_DISTRIBUTE', '分配线索', '');
PrivilegeCode.LEADS_CALL = new PrivilegeCode('LEADS_CALL', '电话外呼', '');
PrivilegeCode.LEADS_PUBLIC_POOL_CALL = new PrivilegeCode('LEADS_PUBLIC_POOL_CALL', '电话外呼', '');
PrivilegeCode.LEADS_UPDATE_STATUS_SCORE = new PrivilegeCode('LEADS_UPDATE_STATUS_SCORE', '标记线索状态、线索评分', '');

PrivilegeCode.LEADS_CALL_RECORD_DOWNLOAD = new PrivilegeCode('LEADS_CALL_RECORD_DOWNLOAD', '通话记录下载', '');
PrivilegeCode.LEADS_COMPANY_EXPORT = new PrivilegeCode('LEADS_COMPANY_EXPORT', '全公司导出线索数据', '');
PrivilegeCode.LEADS_GROUP_EXPORT = new PrivilegeCode('LEADS_GROUP_EXPORT', '团队导出线索数据', '');
PrivilegeCode.LEADS_SELF_EXPORT = new PrivilegeCode('LEADS_SELF_EXPORT', '个人导出线索数据', '');
PrivilegeCode.DEFEAT_LEADS_IMPORT = new PrivilegeCode('DEFEAT_LEADS_IMPORT', '上传战败线索', '');

// 会话管理
PrivilegeCode.CONSULT_VIEW_DETAIL = new PrivilegeCode('CONSULT_VIEW_DETAIL', '查看会话数据详情', '');

// 团队设置

PrivilegeCode.EMPLOYEE_USER_GROUP_VIEW_LIST = new PrivilegeCode('EMPLOYEE_USER_GROUP_VIEW_LIST', '查看团队列表', '');
PrivilegeCode.EMPLOYEE_USER_GROUP_ADD_UPDATE = new PrivilegeCode('EMPLOYEE_USER_GROUP_ADD_UPDATE', '添加/编辑团队', '');
PrivilegeCode.EMPLOYEE_VIEW_LIST = new PrivilegeCode('EMPLOYEE_VIEW_LIST', '查看员工列表', '');
PrivilegeCode.EMPLOYEE_ADD_UPDATE = new PrivilegeCode('EMPLOYEE_ADD_UPDATE', '添加/编辑员工', '');

// 角色权限
PrivilegeCode.ROLE_PRIVILEGE = new PrivilegeCode('ROLE_PRIVILEGE', '查看角色权限说明', '');
PrivilegeCode.INDEPENDENT_PASSWORD_MANAGE = new PrivilegeCode('INDEPENDENT_PASSWORD_MANAGE', '独立密码设置', '');
PrivilegeCode.LEADS_ENCRYPTION_MANAGE = new PrivilegeCode('LEADS_ENCRYPTION_MANAGE', '数据加密设置', '');
PrivilegeCode.LEADS_ENCRYPTION_VIEW = new PrivilegeCode('LEADS_ENCRYPTION_VIEW', '查看数据加密设置', '');

// 线索管理设置
PrivilegeCode.LEADS_DISTRIBUTE_MANAGE = new PrivilegeCode('LEADS_DISTRIBUTE_MANAGE', '分配设置', '');
PrivilegeCode.LEADS_DISTRIBUTE_SETTING_VIEW = new PrivilegeCode('LEADS_DISTRIBUTE_SETTING_VIEW', '线索分配设置查看', '');
PrivilegeCode.LEADS_DISTRIBUTE_SETTING_MANAGE = new PrivilegeCode('LEADS_DISTRIBUTE_SETTING_MANAGE', '线索分配设置管理', '');
PrivilegeCode.LEADS_NOTIFY_MANAGE = new PrivilegeCode('LEADS_NOTIFY_MANAGE', '短信通知设置', '');
PrivilegeCode.LEADS_WECHAT_BINDING = new PrivilegeCode('LEADS_WECHAT_BINDING', '微信绑定', '');

PrivilegeCode.LEADS_API_MANAGE = new PrivilegeCode('LEADS_API_MANAGE', '线索应用设置', '');
PrivilegeCode.BUSINESS_SETTING = new PrivilegeCode('BUSINESS_SETTING', '业务设置', '');

// 数据权限
PrivilegeCode.ACCOUNT_ALL = new PrivilegeCode('ACCOUNT_ALL', '全公司', '');
PrivilegeCode.ACCOUNT_GROUP = new PrivilegeCode('ACCOUNT_ALL', '团队', '');
PrivilegeCode.ACCOUNT_SELF = new PrivilegeCode('ACCOUNT_SELF', '个人', '');
PrivilegeCode.LEADS_ENCRYPTION = new PrivilegeCode('LEADS_ENCRYPTION', '线索加密', '');

// 线索转发设置
PrivilegeCode.LEADS_PUSH_RULE_VIEW = new PrivilegeCode('LEADS_PUSH_RULE_VIEW', '查看线索推送规则', '');
PrivilegeCode.LEADS_PUSH_RULE_EDIT = new PrivilegeCode('LEADS_PUSH_RULE_EDIT', '添加/编辑线索推送规则', '');
PrivilegeCode.LEADS_PUSH_RULE_PAUSE = new PrivilegeCode('LEADS_PUSH_RULE_PAUSE', '启用/暂停线索推送规则', '');
PrivilegeCode.LEADS_PUSH_RULE_TEST_PUSH = new PrivilegeCode('LEADS_PUSH_RULE_TEST_PUSH', '线索推送规则测试', '');
// 线索转发推送模板设置，仅白名单内用户可见
PrivilegeCode.LEADS_PUSH_RULE_TEMPLATE = new PrivilegeCode('LEADS_PUSH_RULE_TEMPLATE', '线索推送模板', '');
// 线索推送记录
PrivilegeCode.LEADS_PUSH_RECORD_VIEW = new PrivilegeCode('LEADS_PUSH_RECORD_VIEW', '查看线索推送记录', '');

PrivilegeCode.LEADS_FIELD_MAPPING_VIEW = new PrivilegeCode('LEADS_FIELD_MAPPING_VIEW', '查看字段值映射配置', '');
PrivilegeCode.LEADS_FIELD_MAPPING_EDIT = new PrivilegeCode(
  'LEADS_FIELD_MAPPING_EDIT',
  '添加/编辑/删除字段值映射配置',
  '',
);

PrivilegeCode.LEADS_FIELD_SPLITTING_VIEW = new PrivilegeCode('LEADS_FIELD_SPLITTING_VIEW', '查看多级字段拆解配置', '');
PrivilegeCode.LEADS_FIELD_SPLITTING_EDIT = new PrivilegeCode(
  'LEADS_FIELD_SPLITTING_EDIT',
  '添加/编辑/删除多级字段拆解配置',
  '',
);

PrivilegeCode.CALL_CLEANING_RULE_MANAGE = new PrivilegeCode(
  'CALL_CLEANING_RULE_MANAGE',
  '智能电话外呼清洗规则设置',
  '',
);

// 无效赔付的两个标签的选择框展示，仅白名单内用户可见
PrivilegeCode.INVALID_PAY = new PrivilegeCode('INVALID_PAY', '无效赔付相关标签', '');

// 粉丝管理
PrivilegeCode.WX_APP_AUTHORIZER_VIEW = new PrivilegeCode('WX_APP_AUTHORIZER_VIEW', '微信公众号授权信息查看', '');
PrivilegeCode.WX_APP_AUTHORIZER_MANAGE = new PrivilegeCode('WX_APP_AUTHORIZER_MANAGE', '微信公众号授权管理', '');
PrivilegeCode.WX_APP_FANS_VIEW = new PrivilegeCode('WX_APP_FANS_VIEW', '公众号粉丝查看', '');
PrivilegeCode.WX_APP_FANS_MANAGE = new PrivilegeCode('WX_APP_FANS_MANAGE', '公众号粉丝管理', '');
PrivilegeCode.WECHAT_USER_TAG_VIEW = new PrivilegeCode('WECHAT_USER_TAG_VIEW', '标签查看', '');
PrivilegeCode.WECHAT_USER_TAG_MANAGE = new PrivilegeCode('WECHAT_USER_TAG_MANAGE', '添加/编辑/删除标签', '');
PrivilegeCode.WX_APP_TAG_RECOG_RULE_VIEW = new PrivilegeCode('WX_APP_TAG_RECOG_RULE_VIEW', '标签识别规则查看', '');
PrivilegeCode.WX_APP_TAG_RECOG_RULE_MANAGE = new PrivilegeCode(
  'WX_APP_TAG_RECOG_RULE_MANAGE',
  '添加/编辑/删除标签识别规则',
  '',
);
PrivilegeCode.WX_APP_MESSAGE_SENDING_RULE_VIEW = new PrivilegeCode(
  'WX_APP_MESSAGE_SENDING_RULE_VIEW',
  '消息发送规则查看',
  '',
);
PrivilegeCode.WX_APP_MESSAGE_SENDING_RULE_MANAGE = new PrivilegeCode(
  'WX_APP_MESSAGE_SENDING_RULE_MANAGE',
  '添加/编辑/删除消息发送规则',
  '',
);
PrivilegeCode.WECHAT_MATERIAL_VIEW = new PrivilegeCode('WECHAT_MATERIAL_VIEW', '微信素材查看', '');
PrivilegeCode.WECHAT_MATERIAL_MANAGE = new PrivilegeCode('WECHAT_MATERIAL_MANAGE', '微信素材管理', '');

Object.freeze(PrivilegeCode);
